import { render, staticRenderFns } from "./PopChronicBloodDetail.vue?vue&type=template&id=23df1f54&lang=pug"
import script from "./PopChronicBloodDetail.vue?vue&type=script&lang=js"
export * from "./PopChronicBloodDetail.vue?vue&type=script&lang=js"
import style0 from "./PopChronicBloodDetail.vue?vue&type=style&index=0&id=23df1f54&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports